<script>
	export let intro;
	export let copyright;
  import Artist from "../Artist.svelte";
  import fetchContent from "../../sanity.js";
  import Loading from "../Loading.svelte";
  import blocksToHtml from '@sanity/block-content-to-html';

  const query = '*[_type == "artist"]{ name, biography, "avatar": avatar.asset -> url, images[] { "src": asset -> url, caption}} | order( name asc )';
  const artists = fetchContent(query);

  let artistIndex
	let chooseArtist = (i) => {
		artistIndex = i
		location.hash = "#artists"
		location.hash = "#artist"
	}
</script>

<section id="artists">
  <h1>Artists</h1>
{@html blocksToHtml({blocks: intro})}
  {#await artists}
    <Loading />
  {:then result}
	<ul class="nav">
	{#each result as artist, i}
		<li on:click={() => chooseArtist(i)}><img src="{artist.avatar}" alt="{artist.name}" class="avatar"></li>
	{/each}
	</ul>
	<div id="artist"></div>
	{#each result as artist, i}
		{#if artistIndex==i}
		<Artist {artist} />
		<a href="#artists" class="button">Choose another artist</a>
		{/if}
	{/each}
	<div class="copyright">
	<h2>Copyright</h2>
	{@html blocksToHtml({blocks: copyright})}
	</div>
	
  {/await}
</section>

<style>
ul.nav {
	list-style: none;
	display: grid;
	grid-template-columns: repeat(auto-fit, 6.5rem);
	gap: 1rem;
	justify-content: center;
	margin: 3rem 0;
	user-select: none;
}

ul.nav li {
	display: grid;
	border-radius: 50% 10% 50% 50%;
	padding: 0.3rem;
	background-color: var(--c-secondary);
	transition: all 0.2s cubic-bezier(.46, .95, .75, .8)
}

ul.nav li:hover {
	border-radius: 50% 50% 10% 50%;
	cursor: pointer;
}

img.avatar {
	display: grid;
	border-radius: 50%;
	width: 100%;
}

.copyright {
	border: 1px solid var(--c-secondary);
	padding: 5vw;
	margin: 1rem auto;
	max-width: 70rem;
}

.copyright :global(p){
	font-size: clamp(0.6rem, 4vw, 1rem);
}

</style>
